console.log("Scrolling promotion JS updated - editor fix loaded");
if (!customElements.get("m-scrolling-promotion")) {
  class MScrollingPromotion extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.promotion = this.querySelector(".m-promotion");
      this.init();
    }

    init() {
      if (!this.promotion) return;

      /*
        Shopify theme editor fix:
        In the editor preview, the marquee animation can cause the page to vibrate.
        So inside the editor, we show the promotion once and do not clone/animate it.
        Live site still works normally.
      */
      if (window.Shopify && window.Shopify.designMode) {
        this.promotion.classList.remove("m-promotion--animated");
        this.classList.add("m-scrolling-promotion--paused");
        return;
      }

      if (this.childElementCount === 1) {
        this.promotion.classList.add("m-promotion--animated");

        for (let index = 0; index < 10; index++) {
          const clone = this.promotion.cloneNode(true);
          clone.setAttribute("aria-hidden", true);
          this.appendChild(clone);
        }

        // Pause when out of view
        const observer = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting) {
                this.scrollingPlay();
              } else {
                this.scrollingPause();
              }
            });
          },
          { rootMargin: "0px 0px 50px 0px" }
        );

        observer.observe(this);
      }
    }

    scrollingPlay() {
      this.classList.remove("m-scrolling-promotion--paused");
    }

    scrollingPause() {
      this.classList.add("m-scrolling-promotion--paused");
    }
  }

  customElements.define("m-scrolling-promotion", MScrollingPromotion);
}
